<template>
  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.8999 13.2002V15.4002L13.0999 12.2002H10.8999C10.3483 12.2002 9.8999 12.6486 9.8999 13.2002Z" fill="currentColor" />
    <path d="M0.899902 0.599609V13.3996C0.899902 14.4996 1.7999 15.3996 2.8999 15.3996H8.8999V13.1996C8.8999 12.0996 9.7999 11.1996 10.8999 11.1996H13.0999V0.599609H0.899902ZM4.2225 9.71681L2.99984 8.79963L2.59984 8.49963L3.19984 7.69963L3.97718 8.28245L5.16156 6.50589L5.9936 7.06057L4.2225 9.71681ZM4.2225 6.11681L2.99984 5.19963L2.59984 4.89963L3.19984 4.09963L3.97718 4.68245L5.16156 2.90589L5.9936 3.46057L4.2225 6.11681ZM10.6999 8.69961H7.0999V7.69961H10.6999V8.69961ZM10.6999 5.09961H7.0999V4.09961H10.6999V5.09961Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Info',
};
</script>
